import { BannerCarouserContainer } from './styles';
import { Swiper, SwiperSlide, useSwiper } from 'swiper/react';
import { Navigation, Pagination, Autoplay } from 'swiper';
import 'swiper/scss';
import 'swiper/scss/navigation';
import 'swiper/scss/pagination';
import { Banner } from '../Banner';
import { useContext, useEffect, useState } from 'react';
import { callFunction } from '../../lib/Helpers';
import { useAppInsightsContext } from '@microsoft/applicationinsights-react-js';
import { TeamsFxContext } from '../../Context';

export interface IBanner {
  backgroundImage?: string;
  bodyText: string;
  buttonLink: string;
  buttonText: string;
  headerText: string;
  id: string;
  isActive: true;
  name: string;
  partitionIndex: string;
  sideImage?: string;
  tooltip: string;
}

export const BannerCarousel = () => {
  const appInsights = useAppInsightsContext();
  const { locale } = useContext(TeamsFxContext);
  const [banners, setBanners] = useState<IBanner[] | IBanner>([]);

  const autoplayDelay = 8000;

  useEffect(() => {
    let mounted = true;

    callFunction(false, 'getBanner?{0}')
      .then((data) => mounted && setBanners(data))
      .catch((error) => {
        if (process.env.REACT_APP_APP_INSIGHTS !== '')
          appInsights.trackException({
            exception: error,
            properties: { component: 'Help', location: 'onGetBanner' },
          });
      });

    return () => {
      mounted = false;
    };
  }, []);

  const swiper = useSwiper();

  return (
    <BannerCarouserContainer slideDuration={autoplayDelay}>
      {Array.isArray(banners) && banners.length > 1 ? (
        <Swiper
          modules={[Navigation, Pagination, Autoplay]}
          navigation={true}
          pagination={{
            el: '.swiper-pagination',
            clickable: true,
            renderBullet: function (index, className) {
              return `<span class="${className}"><div class="slide-progress"></div></span>`;
            },
          }}
          onAutoplayPause={(swiper) => {
            const element =
              swiper.pagination?.bullets[
                swiper.realIndex
              ].querySelector<HTMLElement>('.slide-progress');
            element && (element.style.animationPlayState = 'paused');
          }}
          onAutoplayResume={(swiper) => {
            const element =
              swiper.pagination?.bullets[
                swiper.realIndex
              ].querySelector<HTMLElement>('.slide-progress');
            element && (element.style.animationPlayState = 'running');
          }}
          loop
          autoplay={{
            delay: autoplayDelay,
            disableOnInteraction: false,
            pauseOnMouseEnter: true,
          }}
        >
          <div className="swiper-pagination"></div>
          {banners.map((item, index) => (
            <SwiperSlide key={index}>
              <Banner
                data={item}
                onPlay={swiper?.autoplay?.resume}
                onPause={swiper?.autoplay?.pause}
              />
            </SwiperSlide>
          ))}
        </Swiper>
      ) : (
        <Banner
          data={Array.isArray(banners) ? banners[0] : banners}
          onPlay={swiper?.autoplay?.resume}
          onPause={swiper?.autoplay?.pause}
        />
      )}
    </BannerCarouserContainer>
  );
};
